<template>
  <div class="container-warp">
    <Top-Nav pageTitle="模拟考试" @click-left="pageBack"></Top-Nav>
    <van-tabbar :fixed="false" @change="tabbarChange" v-model="active">
      <van-tabbar-item>待考试</van-tabbar-item>
      <van-tabbar-item>已考试</van-tabbar-item>
    </van-tabbar>
    <van-list v-model="loading" v-if="active==0" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
      <van-cell-group inset v-for="item in list" :key="item.id" class="list-item">
        <div class="list-item-hd">{{ item.examName }}</div>
        <div class="list-item-bd">
          <p>考试模式：{{ item.examModeName }}</p>
          <!-- <p>考试状态：<span class="text-primary">{{ item.examStatus }}</span></p> -->
          <!-- <p>考试时间：{{ item.examTimeStart }}至{{ item.examTimeEnd }}</p> -->
        </div>
        <div class="list-item-foot">
          <van-button type="info" size="small" @click="jumpStartExam(item)" icon="description-o">开始考试</van-button>
        </div>
      </van-cell-group>
    </van-list>
    <!-- 已考试 -->
    <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoadEnd">
      <van-cell-group inset v-for="item in list" :key="item.id" class="list-item">
        <div class="list-item-hd">
          <span>{{ item.examName }}</span>
          <span :class="handleGradesClassName(item)">成绩：{{ item.stuScore || '0' }} / {{ item.examScore || '0' }}</span>
        </div>
        <div class="list-item-bd">
          <p>考试模式：{{ item.examModeName }}</p>
          <p>考试时间：/</p>
          <p>交卷时间：<span class="text-primary">{{ item.endTime }}</span></p>
        </div>
        <div class="list-item-foot">
          <van-button type="info" size="small" @click="jumpViewExam(item)" icon="description-o">查看试卷</van-button>
        </div>
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { chooseExamPaperM,findEndExam,findPendingExamM } from "@/api/exam.js";
export default {
  name: 'WaitExam',
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      active: 0
    }
  },
  computed: {
    ...mapGetters(["userCode"]),
    handleGradesClassName() {
      return function (row) {
        const { stuScore = 0, passScore = 0 } = row
        if (Number(stuScore) >= Number(passScore)) {
          return 'text-green'
        } else {
          return 'text-danger'
        }
      }
    }
  },
  created() {
    this.onLoad()
  },
  methods: {
    tabbarChange() { 
      this.finished = false
      this.pageNum=1,
      this.pageSize=20,
      this.list = []
      // if(this.active==0){
      //   this.onLoad()
      // }else{
      //   this.onLoadEnd()
      // }
    },
    async handleChooseExamPaper(row) {
      const params = { id:row.id,stuId: this.userCode }
      const { status,data } = await chooseExamPaperM(params);
      if (status == 200) {
       this.$router.push({
        path: '/doExam',
        query: {
          examId: row.id,
          examPaperId: data.paperId,
          examStuId: data.examStuId
        }
      })
      }
    },
    async onLoad() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        stuId: this.userCode,
        examMode: 1,
        enabled:1
      }
      // console.log(params)
      const { status, data } = await findPendingExamM(params);
      if (status == 200) {
        let records = data.list || [];
        this.list.push(...records)
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    async onLoadEnd() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        stuId: this.userCode,
        examMode: 1
      }
      // console.log(params)
      const { status, data } = await findEndExam(params);
      if (status == 200) {
        let records = data.list || [];
        this.list.push(...records)
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    // 开始考试页面
    jumpStartExam(row) {// eslint-disable-line no-unused-vars
      // console.log(row)
      this.handleChooseExamPaper(row)
    },
    jumpViewExam(row) {
      // if (!row.endTime) {
      //   this.$toast('不能查看未交卷的考试！')
      //   return
      // }
      this.$router.push({ path: '/viewExam', query: { examStuId: row.examStuId } })
    },
    pageBack() {
      this.$router.push({ path: '/index' })
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/list-style.less");

.list-item {
  .list-item-foot {
    display: flex;
    justify-content: center;
  }
}
</style>
